import styled from 'styled-components'

const IWSpacer = styled('div')`
  flex-grow: 1;
`

export default IWSpacer
